<table class="custom-table">
  <thead>
  <tr>
    @for (column of columns; track $index) {
      <th [ngClass]="'align-' + column.align">
        <div [ngClass]="'table-head-' + column.align">
          <span>{{ column.label }}</span>
          @if (sortColumn === column.key) {
            <img
              class="active"
              (click)="setSort(column.key)"
              (keyup.enter)="setSort(column.key)"
              (keyup.space)="setSort(column.key)"
              tabindex="0"
              [src]="'assets/filter-' + (sortDirection === 'asc' ? 'asc' : 'desc') + '.svg'"
              alt="Filter Icon"
            />
          } @else {
            <img
              (click)="setSort(column.key)"
              (keyup.enter)="setSort(column.key)"
              (keyup.space)="setSort(column.key)"
              tabindex="0"
              src="../../../../../assets/filter.svg"
              alt="Filter Icon"
            />
          }
        </div>
      </th>
    }
  </tr>
  </thead>
  <tbody>
    @for (aggregate of sortedData.length ? sortedData : aggregates; track aggregate.id) {
      <tr>
        <td class="responsive-cell">
          <div class="cell-styling"><span>{{ aggregate.idrId ? aggregate.idrId : '-' }}</span></div>
        </td>
        <td class="responsive-cell">
          <div class="cell-styling"><span>{{ aggregate.name ? aggregate.name : '-' }}</span></div>
        </td>
        <td class="responsive-cell">
          <div class="cell-styling"><span>{{ aggregate.type ? getLabel(aggregate.type) : '-' }}</span></div>
        </td>
        <td class="responsive-cell">
          <div class="cell-styling">
            @if (aggregate.buildingName || aggregate.floor || aggregate.installationSite) {
              <span class="bold-styling">{{ aggregate.buildingName }}</span>
              <span>{{ aggregate.floor }}</span>
              <span>{{ aggregate.room }}</span>
            } @else {
              -
            }
          </div>
        </td>
        <td class="responsive-cell">
          <div class="cell-styling"><span>{{ aggregate.customerProvidedId ? aggregate.customerProvidedId : '-' }}</span>
          </div>
        </td>
        <td class="responsive-cell">
          <span>{{ getInspectionDate(aggregate) ? (getInspectionDate(aggregate) | date:'dd.MM.yyyy') : '-' }}</span>
        </td>
        <td>
          @if (getInspectionStatus(aggregate)) {
            <app-chip [status]="getInspectionStatus(aggregate)" />
          } @else {
            -
          }
        </td>
        <td class="align-middle">
          <div class="cell-styling">
          @if (aggregate.aggregateReport?.reportId && aggregate.aggregateReport?.reportState === AggregateReportState.GENERATED) {
            <div class="cell-styling link">
              <ng-container *ngIf="!isDownloadingReport[aggregate.id]; else repSpin">
                <a
                  (click)="downloadSingleReport(aggregate.id)"
                  (keyup.enter)="downloadSingleReport(aggregate.id)"
                  (keyup.space)="downloadSingleReport(aggregate.id)"
                  tabindex="0"
                >
                  {{ aggregate.aggregateReport?.reportId }}
                </a>
              </ng-container>
              <ng-template #repSpin>
                <p-progressSpinner
                  class="table-spinner"
                  strokeWidth="8"
                  [style]="{ width:'18px', height:'18px' }"
                ></p-progressSpinner>
              </ng-template>
            </div>
          } @else if (aggregate.aggregateReport?.reportId && aggregate.aggregateReport?.reportState === AggregateReportState.NOT_GENERATED) {
            <span>{{ aggregate.aggregateReport?.reportId }}</span>
          } @else {
            -
          }
          <span>{{ aggregate.performanceReportGroup }}</span>
          </div>
        </td>
        <td><img [src]="getCommentImage(aggregate)" (click)="toggleComment(aggregate.id)" style="cursor: pointer;" />
        </td>
        <td><img [src]="getInfoImage(aggregate)" (click)="toggleDetails(aggregate)" style="cursor: pointer;" /></td>
      </tr>
      <tr *ngIf="showComment[aggregate.id]">
        <td colspan="10">
          <p-tabView>
            <p-tabPanel header="Anlagen Kommentare">
              <p>
                @if (aggregate.noteInternalBackoffice) {
                  <app-comment-detail-card
                    title="Backoffice"
                    (click)="openCommentDialog(aggregate.id, aggregate.noteInternalBackoffice, commentType.AGGREGATE_BACKOFFICE_COMMENT)"
                    tabindex="0"
                  ><p>{{ aggregate.noteInternalBackoffice }}</p></app-comment-detail-card>
                }
                @if (aggregate.noteInternalInspector) {
                  <app-comment-detail-card title="Techniker" tabindex="0"
                  ><p>{{ aggregate.noteInternalInspector }}</p></app-comment-detail-card>
                }
                @if (!aggregate.noteInternalBackoffice) {
                  <app-button
                    (click)="openCommentDialog(aggregate.id, aggregate.noteInternalBackoffice, commentType.AGGREGATE_BACKOFFICE_COMMENT)"
                    type="secondary-icon-button"
                    icon="/assets/add.svg"
                    label="Neuer Backoffice Kommentar"
                  />
                }
              </p>
            </p-tabPanel>
            <p-tabPanel header="Hygieneinspektions Kommentare">
              <p>
                @if (aggregate.hygiene?.noteInternalBackoffice) {
                  <app-comment-detail-card
                    title="Backoffice"
                    (click)="openCommentDialog(aggregate.id, aggregate.hygiene?.noteInternalBackoffice, commentType.HYGIENE_BACKOFFICE_COMMENT)"
                    tabindex="0"
                  ><p>{{ aggregate.hygiene?.noteInternalBackoffice }}</p></app-comment-detail-card>
                }
                @if (aggregate.hygiene?.noteInternalInspector) {
                  <app-comment-detail-card title="Techniker" tabindex="0"
                  ><p>{{ aggregate.hygiene?.noteInternalInspector }}</p></app-comment-detail-card>
                }
                @if (aggregate.hygiene?.noteExternalReport) {
                  <app-comment-detail-card title="Bericht" tabindex="0"
                  ><p>{{ aggregate.hygiene?.noteExternalReport }}</p></app-comment-detail-card>
                }
                @if (!aggregate.hygiene?.noteInternalBackoffice) {
                  <app-button
                    (click)="openCommentDialog(aggregate.id, aggregate.hygiene?.noteInternalBackoffice, commentType.HYGIENE_BACKOFFICE_COMMENT)"
                    type="secondary-icon-button"
                    icon="/assets/add.svg"
                    label="Neuer Backoffice Kommentar"
                  />
                }
              </p>
            </p-tabPanel>
              <p-tabPanel header="EnIn Kommentare">
                <p>
                  @if (aggregate.energetic?.noteInternalBackoffice) {
                    <app-comment-detail-card
                      title="Backoffice"
                      (click)="openCommentDialog(aggregate.id, aggregate.energetic?.noteInternalBackoffice, commentType.ENERGETIC_BACKOFFICE_COMMENT)"
                      tabindex="0"
                    ><p>{{ aggregate.energetic?.noteInternalBackoffice }}</p></app-comment-detail-card>
                  }
                  @if (aggregate.energetic?.noteInternalInspector) {
                    <app-comment-detail-card title="Techniker" tabindex="0"
                    ><p>{{ aggregate.energetic?.noteInternalInspector }}</p></app-comment-detail-card>
                  }
                  @if (aggregate.energetic?.noteExternalReport) {
                    <app-comment-detail-card title="Bericht" tabindex="0"
                    ><p>{{ aggregate.energetic?.noteExternalReport }}</p></app-comment-detail-card>
                  }
                  @if (!aggregate.energetic?.noteInternalBackoffice) {
                    <app-button
                      (click)="openCommentDialog(aggregate.id, aggregate.energetic?.noteInternalBackoffice, commentType.ENERGETIC_BACKOFFICE_COMMENT)"
                      type="secondary-icon-button"
                      icon="/assets/add.svg"
                      label="Neuer Backoffice Kommentar"
                    />
                  }
                </p>
            </p-tabPanel>
          </p-tabView>
        </td>
      </tr>
      <tr *ngIf="showDetails[aggregate.id]">
        <td colspan="10">
          <p-tabView>
            @if (hasCancelReasonHygiene(aggregate)) {
              <p-tabPanel header="Abbruchgrund Hygiene">
                <app-notification-card>
                  <p>{{
                      aggregate.hygiene?.cancelReason
                        ? (aggregate.hygiene?.cancelReason + (aggregate.hygiene?.cancelReasonComment ? ': ' + aggregate.hygiene?.cancelReasonComment : ''))
                        : 'Kein Abbruchgrund angegeben'
                    }}</p>
                </app-notification-card>
              </p-tabPanel>
            }
            @if (hasCancelReasonEnergetic(aggregate)) {
              <p-tabPanel header="Abbruchgrund EnIn">
                <app-notification-card>
                  <p>{{
                      aggregate.energetic?.cancelReason
                        ? (aggregate.energetic?.cancelReason + (aggregate.energetic?.cancelReasonComment ? ': ' + aggregate.energetic?.cancelReasonComment : ''))
                        : 'Kein Abbruchgrund angegeben'
                    }}</p>
                </app-notification-card>
              </p-tabPanel>
            }
            @if (hasValidTasks(aggregate)) {
              <p-tabPanel header="Beauftragungen">
                <p-accordion>
                  <p-accordionTab
                    *ngFor="let task of aggregate.hygiene?.remuneratedTasks"
                    [header]="getTaskLabel(task.type) + ' (' + task.done + ' / ' + task.ordered + ')'"
                    [disabled]="!task.notAchievableReason"
                  >
                    <p>
                      <app-notification-card><p>{{ task.notAchievableReason }}</p></app-notification-card>
                    </p>
                  </p-accordionTab>
                </p-accordion>
              </p-tabPanel>
            }
          </p-tabView>
        </td>
      </tr>
    }
  </tbody>
  <tfoot>
  <tr>
    <td colspan="8"></td>
  </tr>
  </tfoot>
</table>

<app-comment-dialog (orderChangedEvent)="updateDetailOnChange()" />
